import Button from "Components/button/button";
import classNames from "classnames";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import find from "lodash/find";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import has from "lodash/has";
import xor from "lodash/xor";
import getScope from "../utils/getScope";
import DateRangeFilter from "./dateRangeFilter";
import ProjectsFilter from "./projectsFilter";
import locale from "./taskStatisticsFilter.locale";
import UsersFilter from "./usersFilter";
import styles from "./taskStatisticsFilter.module.css";
function TaskStatisticsFilter({ onInitialized, onGetTaskStatistics, onClearAllTaskStatisticsFilterParams, onSetTaskStatisticsFilterParams, workSpaces, className, selectedWorkSpaceId, selectedProjectId, filterParams, users }) {
    const [isCleared, setIsCleared] = useState(false);
    const scope = useMemo(() => getScope(selectedProjectId, selectedWorkSpaceId), [selectedProjectId, selectedWorkSpaceId]);
    const selectedWorkSpaceProjectIds = useMemo(() => {
        const selectedWorkSpace = find(workSpaces, ["Id", selectedWorkSpaceId]);
        return selectedWorkSpace ? map(selectedWorkSpace.Projects, "Id") : [];
    }, [selectedWorkSpaceId, workSpaces]);
    const isClearAllDisabled = useMemo(() => {
        if (has(filterParams, "userId") || has(filterParams, "from") || has(filterParams, "to")) {
            return false;
        }
        if (selectedWorkSpaceId) {
            return isEmpty(xor(selectedWorkSpaceProjectIds, filterParams === null || filterParams === void 0 ? void 0 : filterParams.projectId));
        }
        if (selectedProjectId) {
            return isEmpty(xor([selectedProjectId], filterParams === null || filterParams === void 0 ? void 0 : filterParams.projectId));
        }
        return isEmpty(filterParams);
    }, [filterParams, selectedWorkSpaceId, selectedProjectId, selectedWorkSpaceProjectIds]);
    useEffect(() => {
        onInitialized && onInitialized();
    }, []);
    const handleProjectAndWorkSpacesFilterClear = useCallback(() => {
        onSetTaskStatisticsFilterParams &&
            onSetTaskStatisticsFilterParams(scope, { projectId: selectedWorkSpaceProjectIds });
        onGetTaskStatistics && onGetTaskStatistics(scope, { projectId: selectedWorkSpaceProjectIds });
    }, [onGetTaskStatistics, onSetTaskStatisticsFilterParams, selectedWorkSpaceProjectIds, scope]);
    const handleCommonFilterClear = useCallback(() => {
        onClearAllTaskStatisticsFilterParams && onClearAllTaskStatisticsFilterParams(scope);
        onGetTaskStatistics && onGetTaskStatistics(scope);
    }, [onClearAllTaskStatisticsFilterParams, onGetTaskStatistics, scope]);
    const handleClear = useCallback(() => {
        setIsCleared(!isCleared);
        if (selectedProjectId || selectedWorkSpaceId) {
            handleProjectAndWorkSpacesFilterClear();
        }
        else {
            handleCommonFilterClear();
        }
    }, [selectedProjectId, selectedWorkSpaceId, filterParams, isCleared]);
    const handleApplyFilter = useCallback((params) => {
        const newParams = { ...filterParams, ...params };
        onSetTaskStatisticsFilterParams && onSetTaskStatisticsFilterParams(scope, newParams);
        onGetTaskStatistics && onGetTaskStatistics(scope, newParams);
    }, [filterParams]);
    return (React.createElement("div", { className: classNames(styles["filter-container"], className) },
        React.createElement(DateRangeFilter, { onApplyFilter: handleApplyFilter, from: filterParams === null || filterParams === void 0 ? void 0 : filterParams.from, to: filterParams === null || filterParams === void 0 ? void 0 : filterParams.to }),
        !selectedProjectId && (React.createElement(ProjectsFilter, { className: "ml-0_5", caption: locale.WORKSPACE_AND_PROJECT, height: 44, width: 250, popoverWidth: 250, withApplyButton: true, selectedWorkSpaceId: selectedWorkSpaceId, onApplyFilter: handleApplyFilter, projectIds: filterParams === null || filterParams === void 0 ? void 0 : filterParams.projectId, workSpaces: workSpaces, isCleared: isCleared })),
        React.createElement(UsersFilter, { className: "ml-0_5", users: users, onApplyFilter: handleApplyFilter, userIds: filterParams === null || filterParams === void 0 ? void 0 : filterParams.userId, isCleared: isCleared }),
        React.createElement(Button, { disabled: isClearAllDisabled, onClick: handleClear, className: "bg-transparent no-border ml-0_5", height: 36 },
            React.createElement("i", { className: "icon-trash opacity-0_7 font-h5 mr-0_5" }),
            locale.CLEAR_ALL)));
}
export default TaskStatisticsFilter;
